import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { Controller } from '../common/Controller';
import { UiHelper } from '../common/helpers/UiHelper';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiLoginHelper } from '../common/helpers/UiLoginHelper';
import { UsernameInput, PasswordInput, NumericOTPInput } from '../common/components/TextInputs';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../AppConfig';
import { AppTheme, AppStyles } from '../styles/AppTheme';
import { ButtonComponent } from '../components/quizzing/ButtonComponent';
import { CommonStyles } from '../styles/Styles';
import { AppHelper } from '../helpers/AppHelper';

const queryString = require('query-string');

export class Login extends Component {
  constructor(props) {
    super(props);
    if (props.location) {
      this.queryParams = queryString.parse(props.location.search);
    }
    this.userNameType = UiLoginHelper.UserNameType.EMAIL;
    this.state = {
      currentPage: UiLoginHelper.Page.LOOKUP,
      loadingAnimation: false,
      message: '',
      userName: '',
      pword: '',
      verificationCode: ''
    };
    this.options = this.getOptions()
    this.loginHelper = new UiLoginHelper(this, this.options);
  }

  getOptions = () => {
    const options = {
      autoSignUp: false,
      autoLogin: true,
      userNameType: this.userNameType,
      onSuccessLogin: this.onSuccessLogin.bind(this)
    }
    if (this.queryParams && this.queryParams.referral) {
      options.jsonBody = {
        joinReferralCode: this.queryParams.referral
      }
    }
    return options
  }

  onSuccessLogin() {
    Controller.get().userMgr().setGuestUser(false);
    console.log('onSuccessLogin');
    window.location.href = Controller.get().getHomeByRole()
  }

  getPwdRules = () => {
    return (
      <p className={css(Styles.pwdRules)}>Minimum 8 characters with at least one uppercase, lowercase, special character and number</p>
    )
  }

  render() {
    return (
      <div className={css(Styles.outerContainer)}>
        <div className={css(Styles.imgContainer)}>
          <img
            src={require('../assets/images/loginImg.png')}
            className={css(Styles.imgContent)}
          />
        </div>
        <div className={css(Styles.container)}>
          <div className={css(Styles.loginPanel)}>
            <h2 className={css(Styles.loginMainHeader)}>{AppConfig.Title}</h2>
            <div className={css(Styles.loginMessageContainer)}>
              {this.state.message.length > 0 &&
                <p className={css(Styles.loginMessage)}>{this.state.message}</p>
              }
            </div>

            <div className={css(Styles.loginContainer)}>
              {this.state.currentPage === UiLoginHelper.Page.LOOKUP &&
                this.welcomeView()
              }
              {this.state.currentPage === UiLoginHelper.Page.SIGNUP &&
                this.signUpView()
              }
              {this.state.currentPage === UiLoginHelper.Page.SIGNUP_OTP &&
                this.signUpOTPView()
              }
              {this.state.currentPage === UiLoginHelper.Page.LOGIN &&
                this.loginView()
              }
              {this.state.currentPage === UiLoginHelper.Page.RESET_PASSWORD &&
                this.resetPasswordView()
              }
              {this.state.currentPage === UiLoginHelper.Page.RESET_PASSWORD_OTP &&
                this.resetPasswordOTPView()
              }
            </div>
            {AppHelper.getCopyrightString()}
          </div>
        </div>
      </div>
    );
  }

  welcomeView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          placeholder='Enter your email'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })}
          className={css(Styles.textField)}
          disableUnderline={true}
          classes={{
            root: css(Styles.textFieldContentInput),
            input: css(Styles.inputProps),
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitLookup()
            }
          }}
        />

        <div className={css(Styles.btnContainer)}>
          <ButtonComponent
            label='NEXT'
            inProcess={this.state.loadingAnimation}
            onSelect={this.loginHelper.onSubmitLookup.bind(this.loginHelper)}
          />
          <Link to={{
            pathname: '/introduction',
            search: (this.props.location && this.props.location.search) ? this.props.location.search : ''
          }}
          className={css(CommonStyles.link)}>
            <ButtonComponent
              label='INTRODUCTION'
              className={css(Styles.buttonContainerSecond)}
            />
          </Link>
        </div>
        <div className={css(Styles.termsContainer)}>
          <span>By continuing, I agree to the </span><a target='_blank' className={css(Styles.termsLink)} href={AppConfig.termsLink}>terms</a>
        </div>
      </div>
    )
  }

  signUpView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          placeholder='Enter your email'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })}
          className={css(Styles.textField)}
          disableUnderline={true}
          classes={{
            root: css(Styles.textFieldContentInput),
            input: css(Styles.inputProps),
          }}
        />

        <PasswordInput
          value={this.state.pword}
          onChange={(event) => this.setState({ pword: event.target.value })}
          placeholder='Set a new password'
          className={css(Styles.textField)}
          disableUnderline={true}
          classes={{
            root: css(Styles.textFieldContentInput),
            input: css(Styles.inputProps),
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitSignUp()
            }
          }}
        />

        {this.getPwdRules()}

        <div className={css(Styles.btnContainer)}>
          <ButtonComponent
            label='SIGNUP'
            inProcess={this.state.loadingAnimation}
            onSelect={this.loginHelper.onSubmitSignUp.bind(this.loginHelper)}
          />
          <Link to={'/introduction'} className={css(CommonStyles.link)}>
            <ButtonComponent
              label='INTRODUCTION'
              className={css(Styles.buttonContainerSecond)}
            />
          </Link>
        </div>

        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    )
  }

  signUpOTPView() {
    return (
      <div>
        <NumericOTPInput
          id='verificationCode'
          placeholder='Security code'
          value={this.state.verificationCode}
          onChange={(event) => this.setState({ verificationCode: event.target.value })}
          className={css(Styles.textField)}
          disableUnderline={true}
          classes={{
            root: css(Styles.textFieldContentInput),
            input: css(Styles.inputProps),
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitSignUpConfirm()
            }
          }} />

        <div className={css(Styles.btnContainer)}>
          <ButtonComponent
            label='SUBMIT'
            inProcess={this.state.loadingAnimation}
            onSelect={this.loginHelper.onSubmitSignUpConfirm.bind(this.loginHelper)}
          />
          <Link to={'/introduction'} className={css(CommonStyles.link)}>
            <ButtonComponent
              label='INTRODUCTION'
              className={css(Styles.buttonContainerSecond)}
            />
          </Link>
        </div>

        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    )
  }

  loginView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          placeholder='Enter your email'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })}
          className={css(Styles.textField)}
          disableUnderline={true}
          classes={{
            root: css(Styles.textFieldContentInput),
            input: css(Styles.inputProps),
          }} />

        <PasswordInput
          id='pword'
          placeholder={this.inputLabel ? this.inputLabel : 'Enter your password'}
          value={this.state.pword}
          onChange={(event) => this.setState({ pword: event.target.value })}
          className={css(Styles.textField)}
          disableUnderline={true}
          classes={{
            root: css(Styles.textFieldContentInput),
            input: css(Styles.inputProps),
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitLogin()
            }
          }} />

        {this.getPwdRules()}

        {/* <button className="loginButton"
                    onClick={this.loginHelper.onSubmitLogin.bind(this.loginHelper)}>LOGIN</button> */}
        <div className={css(Styles.btnContainer)}>
          <ButtonComponent
            label='LOGIN'
            inProcess={this.state.loadingAnimation}
            onSelect={this.loginHelper.onSubmitLogin.bind(this.loginHelper)}
          />
          <Link to={'/introduction'} className={css(CommonStyles.link)}>
            <ButtonComponent
              label='INTRODUCTION'
              className={css(Styles.buttonContainerSecond)}
            />
          </Link>
        </div>

        <a className={css(Styles.loginLink)} onClick={this.onResetPasswordClicked.bind(this)}><p>Reset password? Get security code</p></a>
        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    );
  }

  resetPasswordView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          placeholder='Enter your email'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })}
          className={css(Styles.textField)}
          disableUnderline={true}
          classes={{
            root: css(Styles.textFieldContentInput),
            input: css(Styles.inputProps),
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitResetPassword()
            }
          }} />

        {/* <button className="loginButton"
                        onClick={this.loginHelper.onSubmitResetPassword.bind(this.loginHelper)}>GET SECURITY CODE</button> */}
        <div className={css(Styles.btnContainer)}>
          <ButtonComponent
            label='GET SECURITY CODE'
            inProcess={this.state.loadingAnimation}
            onSelect={this.loginHelper.onSubmitResetPassword.bind(this.loginHelper)}
          />
          <Link to={'/introduction'} className={css(CommonStyles.link)}>
            <ButtonComponent
              label='INTRODUCTION'
              className={css(Styles.buttonContainerSecond)}
            />
          </Link>
        </div>

        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    )
  }

  resetPasswordOTPView() {
    return (
      <div>
        <NumericOTPInput
          id='verificationCode'
          placeholder='SECURITY CODE'
          value={this.state.verificationCode}
          onChange={(event) => this.setState({ verificationCode: event.target.value })}
          className={css(Styles.textField)}
          disableUnderline={true}
          classes={{
            root: css(Styles.textFieldContentInput),
            input: css(Styles.inputProps),
          }} />

        <PasswordInput
          id='pword'
          placeholder={this.inputLabel ? this.inputLabel : 'Enter your password'}
          value={this.state.pword}
          onChange={(event) => this.setState({ pword: event.target.value })}
          className={css(Styles.textField)}
          disableUnderline={true}
          classes={{
            root: css(Styles.textFieldContentInput),
            input: css(Styles.inputProps),
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitConfirmResetPassword()
            }
          }} />

        {this.getPwdRules()}

        {/* <button className="loginButton"
                    onClick={this.loginHelper.onSubmitConfirmResetPassword.bind(this.loginHelper)}>SUBMIT</button> */}
        <div className={css(Styles.btnContainer)}>
          <ButtonComponent
            label='SUBMIT'
            inProcess={this.state.loadingAnimation}
            onSelect={this.loginHelper.onSubmitConfirmResetPassword.bind(this.loginHelper)}
          />
          <Link to={'/introduction'} className={css(CommonStyles.link)}>
            <ButtonComponent
              label='INTRODUCTION'
              className={css(Styles.buttonContainerSecond)}
            />
          </Link>
        </div>
        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    )
  }

  onStartoverClicked() {
    this.loginHelper.toPage(UiLoginHelper.Page.LOOKUP);
  }

  onResetPasswordClicked() {
    this.loginHelper.toPage(UiLoginHelper.Page.RESET_PASSWORD);
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      margin: 10,
      minHeight: '96vh',
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      flexDirection: 'column',
    },
  },
  imgContainer: {
    flex: 1,
    maxWidth: 350,
    maxHeight: 350,
    '@media (max-width: 768px)': {
      maxWidth: 175,
      maxHeight: 175,
    },
    '@media (max-width: 330px)': {
      maxWidth: 120,
      maxHeight: 120,
    }
  },
  imgContent: {
    width: '100%',
    height: '100%',
  },
  container: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    flex: 1,
    '@media (max-width: 768px)': {
      flex: 0,
      marginTop: 10
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      marginTop: 30
    },
  },
  loginPanel: {
    textAlign: 'center',
    // minWidth: 510,
    marginLeft: 100,
    padding: 0,
    backgroundColor: AppTheme.primaryBg,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      padding: 5,
      marginLeft: 0,
      minWidth: 'unset'
    },
    '@media(min-width: 768px) and (max-width: 1024px)': {
      marginLeft: 20,
      minWidth: 'unset',
    },
  },
  loginMessageContainer: {
    margin: 0,
    height: 20,
    marginTop: 20,
    marginBottom: 5,
    '@media (max-width: 767px)': {
      marginTop: 10,
      marginBottom: 0,
    },
  },
  loginMessage: {
    margin: 0,
    color: AppTheme.secondaryColor,
  },
  loginLink: {
    marginTop: 10,
    cursor: 'pointer',
    color: AppTheme.tertiaryColor,
    fontSize: 14,
    textTransform: 'uppercase'
  },
  btnContainer: {
    paddingTop: 10,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  marginLeft: {
    marginLeft: 10,
    color: 'white'
  },
  termsContainer: {
    fontSize: 14,
  },
  termsLink: {
    color: AppTheme.tertiaryColor,
    textDecoration: 'none',
  },
  loginMainHeader: {
    fontSize: 48,
    fontWeight: 'normal',
    margin: AppTheme.pMargin,
    '@media (max-width: 768px)': {
      fontSize: 30,
    },
  },
  loginSubHeader: {
    fontSize: 35,
    fontWeight: 'normal',
    margin: AppTheme.pMargin,
    marginTop: 15,
    '@media (max-width: 767px)': {
      fontSize: 25,
    }
  },
  loginContainer: {
    width: 300
  },
  buttonContainer: {
    backgroundColor: AppTheme.secondaryColor,
    borderRadius: 25,
    fontSize: 17,
    padding: 8,
    color: AppTheme.tertiaryBg,
  },

  textField: {
    maxWidth: 320,
    maxHeight: 60,
    background: AppTheme.secondaryBg,
    border: '3px solid' + AppTheme.borderColor,
    zIndex: 0,
    borderRadius: 18,
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: 20
  },
  textFieldContentInput: {
    padding: 5,
    paddingLeft: 10,
    fontSize: AppTheme.subTitleSize,
    color: AppTheme.primaryColor,
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767
    }
  },
  inputProps: {
    textAlign: 'center'
  },
  buttonContainerSecond: {
    minWidth: 200,
    fontSize: 22,
    borderRadius: 30,
    fontWeight: 'normal',
    margin: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      minWidth: 100,
      fontSize: 18,
      borderRadius: 25,
    },
    backgroundColor: 'transparent',
    boxShadow: 'unset',
    color: AppTheme.tertiaryColor,
  },
  pwdRules: {
    fontSize: 10,
    color: AppTheme.primaryColor,
    marginBottom: 0,
  }
})



// WEBPACK FOOTER //
// ./src/screens/Login.js